<template>
  <div>
    <page-header
      has-return
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="onReturn"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

export default {
  name: 'ReferralInform',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
          caat: null,
          sieNumber: null,
          referralNumber: null,
        },
        collections: {
          academicYears: [],
          caats: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Referidos de Asistencia Tecnológica',
        icon: 'fa-solid fa-file-alt font-22 ',
        routes: ['Inicio', 'Referidos de Asistencia Tecnológica'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'caat',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CAAT',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.caats,
          value: this.model.search.filters.caat,
        },
        {
          name: 'sieNumber',
          component: 'CustomInput',
          type: 'text',
          maskType: 'SIE',
          label: 'Número de SIE',
          placeholder: 'Escriba número de SIE',
          class: 'col-md-4',
          value: this.model.search.filters.sieNumber,
        },
        {
          name: 'referralNumber',
          component: 'CustomInput',
          type: 'text',
          label: 'Número de Referido',
          placeholder: 'Número de Referido',
          class: 'col-md-4',
          value: this.model.search.filters.referralNumber,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      await this.getCaats();
      const { data } = await AcademicYearServices.getCurrentYearAcademicYears();
      this.model.search.collections.academicYears = data;
    },
    async getCaats() {
      const { data } = await referralAndEquipmentsservice.getCaats();
      this.model.search.collections.caats = data;
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) return;
      await this.process();
    },
    async process() {
      try {
        const f = this.model.search.filters;
        const params = {
          academicYearId: f.academicYear.id,
        };
        if (f.caat?.id != null) {
          params.caatId = f.caat.id;
        }
        const sie = this.parseStudentSieId(f.sieNumber);
        if (sie != null) {
          params.studentSieId = sie;
        }
        const referral = f.referralNumber?.trim();
        if (referral) {
          params.referralNumber = referral;
        }
        const { data } = await ReportServices.getReport('referralatinform', params);
        DocumentServices.Download(data);
      } catch {
        this.ShowToast('Error', 'Error al intentar cargar el reporte', 'error');
      }
    },
    parseStudentSieId(value) {
      if (value == null || value === '') return null;
      const n = Number(String(value).replace(/\D/g, ''));
      return Number.isNaN(n) ? null : n;
    },
    onReturn() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped></style>
